export var PRODUCT_EXTRA_ENRICHMENT_FIELDS = [{
  key: 'builderId'
}, {
  key: 'newbuildingId'
}, {
  key: 'type'
}, {
  key: 'builderName'
}, {
  key: 'url',
  alias: 'hitUrl'
}, {
  key: 'title',
  alias: 'creativeTitle'
}, {
  key: 'description',
  alias: 'creativeText'
}];